// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__fXzkD","label":"Section_label__3cSNk","contentWrap":"Section_contentWrap__3A0CA","footer":"Section_footer__1Dq8y","footerInner":"Section_footerInner__2bw4a"};